import { ChildrenModelBase } from './children-base.model';

export class CombinerAction extends ChildrenModelBase {
  name: string;
}
